import React from 'react';
export function SmartWireSection() {
  return <div className="mt-8" data-id="element-1734">
      <div className="bg-[#1874cd] py-8 px-4" data-id="element-1735">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center max-w-4xl mx-auto" data-id="element-1736">
          Unlock the power of your AgieCharmilles CUT series Wire EDM machine
          with <span className="text-3xl md:text-4xl" data-id="element-1737">SMART Wire</span>
        </h2>
      </div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-1738">
        <div className="grid md:grid-cols-2 gap-12 items-start bg-white p-8 md:p-12 rounded-xl shadow-sm border border-gray-200 mb-8" data-id="element-1739">
          <div className="space-y-8" data-id="element-1740">
            <h3 className="text-2xl font-bold text-navy" data-id="element-1741">
              What You Should Know:
            </h3>

            <div className="space-y-6" data-id="element-1742">
              <div data-id="element-1743">
                <h4 className="text-xl font-bold text-orange mb-2" data-id="element-1744">
                  Process Continuity
                </h4>
                <p className="text-gray-700" data-id="element-1745">
                  Wire length monitoring advances your unmanned productivity and
                  your confidence that wire length is sufficient to complete the
                  process.
                </p>
              </div>
              <div data-id="element-1746">
                <h4 className="text-xl font-bold text-orange mb-2" data-id="element-1747">
                  Process Traceability
                </h4>
                <p className="text-gray-700" data-id="element-1748">
                  Information in the machine report collects wire data
                  (manufacturing date, lot number, wire type, etc.) to meet your
                  customers' traceability requirements.
                </p>
              </div>
              <div data-id="element-1749">
                <h4 className="text-xl font-bold text-orange mb-2" data-id="element-1750">
                  Process Enhancement
                </h4>
                <p className="text-gray-700" data-id="element-1751">
                  Automatic wire technology check ensures that your wire
                  technology matches the wire loaded on the machine and
                  optimizes your performance.
                </p>
              </div>
            </div>
          </div>

          <div className="w-full aspect-video rounded-xl overflow-hidden shadow-lg" data-id="element-1752">
            <iframe className="w-full h-full" src="https://www.youtube.com/embed/X8H9IUOdHII?wmode=opaque" title="SMART Wire Video" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-1753"></iframe>
          </div>
        </div>

        <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200" data-id="element-1754">
          <p className="text-gray-700 text-lg leading-relaxed text-justify" data-id="element-1755">
            With SMART wire, GF Machining Solutions positions you to use your
            machine to its full potential and achieve Industry 4.0-level process
            control. SMART wire spools are equipped with radio frequency
            identification (RFID) chips to store wire characteristics and
            traceability-related data. SMART wire helps you avoid unexpected
            interruptions by monitoring the wire length remaining on your
            machine, and wire traceability is enhanced by the wire data in the
            machine report. Furthermore, you always know you're using the
            correct wire because SMART wire checks the wire technology selected
            on the machine.{' '}
            <a href="https://www.peakedm.com/uploaded/files/EDM%20Consumables%20-%20smart-wires-en.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="text-orange font-bold hover:underline" data-id="element-1756">
              Click Here to Learn More
            </a>
          </p>
        </div>
      </div>
    </div>;
}